export default __webpack_public_path__ + "static/media/bg-image-11.61ce8c40.jpg";